export const SET_LAWS_DEADLINES_LOST_FETCHING = 'SET_LAWS_DEADLINES_LOST_FETCHING';
export const SET_LAWS_DEADLINES_LOST_FETCHING_ERROR = 'SET_LAWS_DEADLINES_LOST_FETCHING_ERROR';
export const SET_LAWS_DEADLINES_LOST = 'SET_LAWS_DEADLINES_LOST';
export const CLEAN_LAWS_DEADLINES_LOST = 'CLEAN_LAWS_DEADLINES_LOST';
export const ABORT_DEADLINES_LOST_REQUEST = 'ABORT_DEADLINES_LOST_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsDeadlinesLost/actions.js